import type { MouseEvent, ReactElement } from "react";

import { IconButton } from "@similarweb/ui-components";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import {
    StyledOnboardingHubButtonSmallTitle,
    StyledOnboardingHubButtonSubSmallTitle,
    StyledOnboardingHubButtonSubTitle,
    StyledOnboardingHubButtonTitle,
    StyledOnboardingHubCloseButton,
    StyledOnboardingHubProgressWrapper,
    StyledOnboardingHubTitle,
    StyledOnboardingHubTitleWrapper,
} from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/components/OnboardingHubHeader/styles";
import type {
    OnboardingHubProgressBaseProps,
} from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/components/OnboardingHubProgress/OnboardingHubProgress";
import OnboardingHubProgress from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/components/OnboardingHubProgress/OnboardingHubProgress";

export interface OnboardingHubHeaderBaseProps {
    isShowClose?: boolean;
    onClose?: () => void;
}

interface Props extends OnboardingHubHeaderBaseProps, OnboardingHubProgressBaseProps {
    isExtended?: boolean;
}

const OnboardingHubHeader = ({
    isExtended,
    isShowClose,
    onClose,
    completedItemsCount: completedItems,
    totalItemsCount: totalItems,
}: Props): ReactElement => {
    const handleClose = (e: MouseEvent<SVGElement>) => {
        e?.stopPropagation();

        if (!onClose) {
            return;
        }

        onClose();
    };

    return (
        <StyledOnboardingHubProgressWrapper
            isInSidebar={!isExtended}
            isCentered={!totalItems}
        >
            <StyledOnboardingHubTitleWrapper>
                <StyledOnboardingHubTitle isInSidebar={!isExtended}>
                    <I18n
                        translatable={{
                            key:
                                isExtended || !totalItems
                                    ? "si.onboarding.hub.sidebar-button.title"
                                    : "si.onboarding.hub.sidebar-button.getting-started",
                        }}
                        element={isExtended ? StyledOnboardingHubButtonTitle : StyledOnboardingHubButtonSmallTitle}
                    />

                    {(isExtended || totalItems > completedItems) ? <I18n
                            translatable={{
                                key: "si.onboarding.hub.progress",
                                replacements: { completedItems, totalItems },
                            }}
                            element={
                                isExtended ? StyledOnboardingHubButtonSubTitle : StyledOnboardingHubButtonSubSmallTitle
                            }
                        /> : null}
                </StyledOnboardingHubTitle>
                {isShowClose ? (
                    <StyledOnboardingHubCloseButton isExtended={isExtended}>
                        <IconButton
                            type="flat"
                            iconSize="xs"
                            iconName="clear"
                            onClick={handleClose}
                        />
                    </StyledOnboardingHubCloseButton>
                ) : null}
            </StyledOnboardingHubTitleWrapper>
            {totalItems > 0 ? <OnboardingHubProgress
                    completedItemsCount={completedItems}
                    totalItemsCount={totalItems}
                    isBold={!!isExtended}
                /> : null}
        </StyledOnboardingHubProgressWrapper>
    );
};

export default OnboardingHubHeader;
